exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".editor-___Editor__presets___2ZzjC {\n  margin-left: 15px;\n  margin-top: 6px;\n}\n\n.editor-___Editor__presets___2ZzjC button {\n  margin-left: 25px;\n}\n\n.editor-___Editor__gh___kXTEX {\n  margin: 14px 10px 0;\n}\n\n.editor-___Editor__expectedOverlay___mXruU {\n  padding: 5px;\n  border: 1px solid #aa6666;\n  white-space: pre;\n  background-color: rgba(255, 255, 255, 0.8);\n}", ""]);

// Exports
exports.locals = {
	"presets": "editor-___Editor__presets___2ZzjC",
	"gh": "editor-___Editor__gh___kXTEX",
	"expectedOverlay": "editor-___Editor__expectedOverlay___mXruU"
};